import { TYPO } from "styles/Typo";

// 버튼 타입과 크기를 위한 타입 정의
type ButtonType = "primary" | "secondary" | "disabled";
type ButtonSize = "sm" | "md" | "lg" | "xl"; // 다른 버튼 크기 추가 가능

interface ButtonProps {
  type: ButtonType;
  size: ButtonSize;
  disabled?: boolean;
  text: string;
  width?: string;
  btnClass?: string;
  isDesktop?: boolean;
  absolute?: boolean;
  rounded?: boolean;
  onclick?: (value: any) => void;
  zIndex?: number;
  dataGtmId?: string;
  customStyle?: React.CSSProperties;
}

const FixedButton = ({
  type,
  text,
  size,
  width,
  disabled,
  btnClass,
  isDesktop,
  absolute,
  rounded,
  onclick,
  zIndex,
  dataGtmId,
  customStyle,
}: ButtonProps) => {
  const baseStyles = `inline-flex flex justify-center items-center w-full `;

  const colorStyle = {
    disabled:
      type === "primary"
        ? "!bg-blue-500 !bg-opacity-30 !text-white"
        : "!bg-gray20 !text-gray40",
    primary: "bg-blue40 !text-white ",
    secondary: "bg-blue5 !text-blue50",
  };
  const sizeStyles = {
    sm: ` h-8 px-2 py-1.5 ${rounded && "rounded-lg"}  ${TYPO.TYPO8_MD}`,
    md: ` h-10 px-[11px] py-2 ${rounded && "rounded-[10px]"}  ${
      TYPO.TYPO7_MD
    } `,
    lg: `
    
    h-12 px-4 py-[11px] ${rounded && "rounded-xl"}  ${TYPO.TYPO6_MD}`,
    xl: ` h-[54px] px-[18px] py-[13px] ${rounded && "rounded-[14px]"}  ${
      TYPO.TYPO5_MD
    }`,
  };

  const buttonClass = `${btnClass && btnClass} ${baseStyles} ${
    type && disabled ? colorStyle["disabled"] : colorStyle[type]
  } ${size && sizeStyles[size]} ${width} ${disabled ? "" : "cursor-pointer"} `;
  // if (absolute)
  //   return (
  //     <div
  //       onClick={onclick}
  //       className={`absolute bottom-0 w-full left-0 ${
  //         rounded ? " px-5 pt-4 pb-9" : ""
  //       }`}
  //     >
  //       <button className={buttonClass}>
  //         <p>{text}</p>
  //       </button>
  //     </div>
  //   );
  // return (
  //   <div
  //     className={`${
  //       isDesktop ? "w-[800px] left-[50%] translate-x-[-50%]" : "w-full left-0"
  //     } fixed bottom-0 bg-white ${rounded ? " px-5 pt-4 pb-9" : ""} `}
  //     onClick={onclick}
  //   >
  //     <button className={buttonClass}>
  //       <p>{text}</p>
  //     </button>
  //   </div>
  // );
  if (!isDesktop)
    //absolute 인 경우는 모바일 가상키보드 위에 붙이는 경우
    return (
      <div
        onClick={onclick}
        style={{
          background:
            "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.85) 10%, rgba(255, 255, 255, 0.95) 40.14%, #FFF 100%)",
          ...(customStyle || {}),
        }}
        className={`${
          absolute ? "absolute" : `fixed ${zIndex ? `z-[${zIndex}]` : ""} `
        } bottom-0 w-full left-0 bg-white ${rounded ? " px-5 pt-4 pb-9" : ""}`}
        data-gtm-id={dataGtmId}
      >
        <button className={buttonClass}>
          <p>{text}</p>
        </button>
      </div>
    );
  return (
    <div
      style={{
        background:
          "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.85) 10%, rgba(255, 255, 255, 0.95) 40.14%, #FFF 100%)",
        ...(customStyle || {}),
      }}
      className={`${
        isDesktop ? "w-[800px] left-[50%] translate-x-[-50%]" : "w-full left-0"
      } absolute bottom-[0px] bg-white ${rounded ? " px-5 pt-4 pb-9" : ""} ${
        zIndex ? `z-[${zIndex}]` : ""
      } ${disabled ? "" : "cursor-pointer"}`}
      onClick={onclick}
      data-gtm-id={dataGtmId}
    >
      <button className={buttonClass}>
        <p>{text}</p>
      </button>
    </div>
  );
};

export const FixedButtonContainer = ({
  children,
  isMobile,
  className,
  customStyle,
  dataGtmId,
}: {
  children: React.ReactNode;
  isMobile: boolean;
  className?: string;
  customStyle?: React.CSSProperties;
  dataGtmId?: string;
}) => {
  return (
    <div
      className={`fixed bottom-0 w-full left-0 bg-white px-5 pt-4 pb-9 ${
        !isMobile
          ? "!max-w-[800px] w-screen !left-[50%] translate-x-[-50%]"
          : ""
      } ${className}`}
      style={{
        background:
          "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.85) 10%, rgba(255, 255, 255, 0.95) 40.14%, #FFF 100%)",
        ...(customStyle || {}),
      }}
      data-gtm-id={dataGtmId}
    >
      {children}
    </div>
  );
};
export default FixedButton;
